import React from 'react';
import { companyInfo } from '../mock';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/si2vae0p_IMG_20260101_084232.jpg" 
                alt="Structure Savers Logo"
                className="h-16 w-auto object-contain bg-white rounded-2xl p-2"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 font-light text-lg max-w-md">
              Your trusted partner for waterproofing, structural repairs, and complete construction solutions. Building trust and restoring strength, one project at a time.
            </p>
          </div>

          <div>
            <h4 className="text-xl font-extrabold mb-6 tracking-tight">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-white transition-colors font-light text-lg hover:translate-x-2 inline-block transition-transform">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-white transition-colors font-light text-lg hover:translate-x-2 inline-block transition-transform">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white transition-colors font-light text-lg hover:translate-x-2 inline-block transition-transform">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-white transition-colors font-light text-lg hover:translate-x-2 inline-block transition-transform">
                  Contact
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('quote')} className="text-gray-400 hover:text-white transition-colors font-light text-lg hover:translate-x-2 inline-block transition-transform">
                  Get Quote
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-extrabold mb-6 tracking-tight">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-gray-400 font-light">{companyInfo.phone}</p>
                  <p className="text-gray-400 font-light">{companyInfo.alternatePhone}</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
                <p className="text-gray-400 font-light">{companyInfo.email}</p>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
                <p className="text-gray-400 font-light">{companyInfo.address}</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 font-light">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;